module.exports = __webpack_public_path__ + "img/momo_button_redeem.7e49f034.png";